/**
 * Configuration resolved at runtime from /config.js, so the same built image serves local, staging and
 * production. Vite environment variables remain the fallback for `pnpm dev`.
 */
export interface RuntimeConfig {
  apiUrl: string;
  oidcAuthority: string;
  oidcClientId: string;
  defaultLocale: string;
  /** Where a support session opens the roastery application (US-14.3); `?support=<id>` is appended. */
  appUrl: string;

  /** GlitchTip DSN of this application (US-18.9); empty = error tracking off. */
  sentryDsn?: string;
  /** Which installation (local, prod) and which commit - tags on every error event. */
  environment?: string;
  release?: string;
}

declare global {
  interface Window {
    __ROASTERY_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const fallback: RuntimeConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? "http://api.localhost",
  oidcAuthority: import.meta.env.VITE_OIDC_AUTHORITY ?? "http://auth.localhost/realms/roastery-manager",
  oidcClientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? "platform-admin",
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? "pl",
  appUrl: import.meta.env.VITE_APP_URL ?? "http://app.localhost",
};

export const runtimeConfig: RuntimeConfig = {
  ...fallback,
  ...(window.__ROASTERY_CONFIG__ ?? {}),
};
